export default "__VITE_ASSET__326878c6__"